const addressRegex = /^0x[a-fA-F0-9]{40}$/;
function isAddress(address) {
  return addressRegex.test(address);
}
function assertAddress(value) {
  if (!value.startsWith("0x"))
    throw Error(`Unexpected value ${JSON.stringify(value)} is not an address`);
}
function assertAddressList(list) {
  list.forEach(assertAddress);
}

export { assertAddress, assertAddressList, isAddress };
